import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import { ResultDisplayWriting } from '@/components/results/ResultDisplayWriting';
import { RESULT_DISPLAY_SIZE } from '@/constant';
import { isSlideComponentStrokeWriting, Question } from '@/types/slide';
import { isCorrectnessDeterminable } from '@/utils/score';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDuration } from '../../format';
import { ResultContainer, ResultContent, ResultTitle } from '../ResultCard';
import { ResultCardUnsupported } from './ResultCardUnsupported';

export const ResultCardStrokeWriting: React.FC<{ question: Question }> = ({ question }) => {
    const { t } = useTranslation();

    if (!isSlideComponentStrokeWriting(question)) {
        return <ResultCardUnsupported question={question} />;
    }

    const caption = question.answers.length === 0 ? t('result.message.noResult') : t('result.message.replayStroke');
    const timeSpent = formatDuration(question.answers.reduce((total, answer) => total + (new Date(answer.endTime).getTime() - new Date(answer.startTime).getTime()), 0) / 1000);

    // only care the latest answer
    const answer = question.answers[0];
    const scored = !isCorrectnessDeterminable(question) || answer?.correct;
    return (
        <>
            <ResultContainer>
                <Stack spacing={1}>
                    <Box sx={{ display: 'flex' }}>
                        <ResultTitle variant='h5'>{t('slide.components.strokeWriting.title')}</ResultTitle>
                        <Box sx={{ flexGrow: 1 }} />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography color={question.answers.length > 0 ? 'text.secondary' : 'text.warning'}>{caption}</Typography>
                        {question.answers.length > 0 && (
                            <Typography color='text.secondary'>
                                {t('result.label.timeSpent')}: {timeSpent}
                            </Typography>
                        )}
                    </Box>
                </Stack>
                <ResultContent sx={{ minWidth: '320px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Box sx={{ width: RESULT_DISPLAY_SIZE.width, height: RESULT_DISPLAY_SIZE.height }}>
                        <ResultDisplayWriting type='question' question={question} viewOnly={false} />
                    </Box>
                </ResultContent>
                <Box
                    sx={(theme) => ({
                        backgroundColor: !answer ? 'transparent' : scored ? (theme.vars || theme).palette.success.main : (theme.vars || theme).palette.error.main,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        p: 1,
                        borderRadius: '4px',
                    })}
                >
                    {!answer ? (
                        <Typography variant='h5' color='warning' textAlign={'center'}>
                            {t('result.label.noResult')}
                        </Typography>
                    ) : scored ? (
                        <CheckIcon style={{ color: 'white' }} />
                    ) : (
                        <CloseIcon style={{ color: 'white' }} />
                    )}
                </Box>
            </ResultContainer>
        </>
    );
};
